import api, { API_PATHS } from "./api";
import { AppDispatch } from "../store";
import { setNotification } from "../store/toastNotifications";

export type Ruleset = {
  id: number;
  name: string;
};

class RulesetService {
  static async getRulesets(dispatch: AppDispatch): Promise<Ruleset[]> {
    try {
      const response = await api.get<Ruleset[]>(API_PATHS.getRulesets);
      return response.data;
    } catch (error: any) {
      dispatch(
        setNotification({
          message:
            "Vi kunne desværre ikke hente regelsættene. Prøv igen eller kontakt support.",
        }),
      );
      throw new Error(error.message);
    }
  }
  static async runOptimizationWithRuleset(
    rulesetId: number,
    idScenario: number,
    dispatch: AppDispatch,
  ): Promise<void> {
    try {
      await api.post(API_PATHS.startOptimization, {
        idRuleset: rulesetId,
        idScenario,
      });
    } catch (error: any) {
      dispatch(
        setNotification({
          message:
            "Vi kunne desvære ikke starte optimeringen med det valgte regelsæt. Prøv igen, eller kontakt support.",
        }),
      );
      throw new Error(error.message);
    }
  }
}

export default RulesetService;
